/**
 * Voicemail message class
 */
export default class {
  constructor (data) {
    this.id = ~~data.id
    this.isRead = data.is_read
    this.dir = data.dir
    this.favorite = data.favorite
    this.favoriteIcon = this.favorite ? 'mdi-star' : 'mdi-star-outline'
    this.duration = ~~data.duration
    this.time = Date.parse(data.origtime)
    this.folder = data.folder
    this.folderIcon = this.folderIcon(this.folder)
    this.callerid = data.callerid
    this.transcription = data.transcription
    this.transcriptionSummary = data.transcription_summary
    this.transcriptionCategory = data.transcription_category
    this.translationLanguage = data.translationLanguage
    this.translation = data.translation
    this.callerName = ''
    this.callerNum = ''
    this.isCustomFolder = !this.dir.match('/Old') && !this.dir.match('/INBOX')
    this.customFolder = this.isCustomFolder ? data.dir.split('/').pop() : ''

    // parse caller id
    const cid = this.callerid.match(/"([^"]+)"\s+<([^>]+)>/)
    if (cid) {
      this.callerName = cid[1]
      this.callerNum = cid[2]
    }
  }

  /**
   * Parse SIP NOTIFY method body of SIP Event "message-summary"
   *
   * @param {String} body SIP event body
   * @return {Object} NULL on error or object waiting: Bool, account: String, new: Int, old: Int
   */
  static parseMWIBody (body) {
    const vm = {}
    let m // TODO: refactor this
    if (typeof body !== 'string') {
      return null
    }

    const data = body.split('\r\n').filter(l => l.trim().length > 0)
    if (data.length !== 3) {
      return null
    }

    for (const line of data) {
      const val = line.split(':')
      switch (val[0]?.toLowerCase()) {
        case 'messages-waiting':
          vm.waiting = val[1].trim().toLowerCase() === 'yes'
          break
        case 'message-account':
          vm.account = val.splice(1).join(':').trim()
          break
        case 'voice-message':
          m = val[1].trim().split(' ')[0]
          vm.new = parseInt(m.split('/')[0])
          vm.old = parseInt(m.split('/')[1])
          break
        default:
          // invalid or corrupted
          return null
      }
    }
    return vm
  }

  folderIcon (name) {
    switch (name) {
      case 'inbox':
        return 'mdi-email'
      case 'old':
        return 'mdi-email-open'
      default:
        return 'mdi-folder'
    }
  }

  favoriteIcon () {
    return this.favorite ? 'mdi-star' : 'mdi-star-outline'
  }
}
